// ConfigurationForm.js
import React, { useContext, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { AppContext } from "../context/AppContext";
import { MASTERCONFIG } from "../config/general";

function ConfigurationForm() {
  const { login } = useContext(AppContext);
  const [config, setConfig] = useState({
    remote: false,
    mongoDBURL: "",
    port: ""
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setConfig({
      ...config,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("")
    setSuccess("")
    let regex = /^mongodb:\/\/([a-zA-Z0-9\-]+(:[a-zA-Z0-9\-]+)?@)?[a-zA-Z0-9\-\.]+(:\d+)?(\/[a-zA-Z0-9\-]+)?$/;
    if (config.port == config.peerPort) {
      setError("Both ports can't be same.")
      return
    }
    if (!regex.test(config.mongoDBURL)) {
      setError("InValid MongoDB connection url");
      return
    }
    const validateObj = {
      email: config.email,
      password: config.password,
      key: config.key,
    }
    try {
      const response = await fetch(
        MASTERCONFIG.REACT_APP_ENDPOINT + "/api/auth/validate-key",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(validateObj),
        }
      );
      const res = await response.json();
      if (!res.success) {
        setError(res.message)
        return
      }
      let obj = {
        remote: config.remote || false,
        mongoDBURL: config.mongoDBURL,
        port: config.port,
        peerPort: config.peerPort,
        key: config.key,
        createdAt: new Date(),
      }
      localStorage.removeItem("ipConfig")
      const result = await window.electronAPI.saveConfig(obj);
      if (result.success) {
        setSuccess(`Your config was saved successfully.connecting you to admin`);
        setTimeout(() => {
          window.location.href = `http://localhost:${config.port}`;
        }, 5000)
      } else {
        setError(result.message);
      }
    } catch (error) {
      console.error("Error saving configuration:", error);
    }
  };

  return (
    <>
      {!login.isLogin && <Header />}
      <main>
        <form onSubmit={handleSubmit} className="container mt-4 p-4 border rounded bg-light">
          <div className="mb-3 d-flex align-items-center gap-2">
            <label className="form-check-label" htmlFor="remote">
              Enable Remote Setup
            </label>
            <input
              type="checkbox"
              id="remote"
              name="remote"
              checked={config.remote}
              onChange={(e) => setConfig({ ...config, remote: e.target.checked })}
              className="form-check-input"
            />
          </div>
          <div className="mb-3">
            <label className="form-label" for="email">Email:</label>
            <input
              type="text"
              id="email"
              name="email"
              value={config.email}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label" for="password">Password:</label>
            <input
              type="text"
              id="password"
              name="password"
              value={config.password}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label" for="key">Key:</label>
            <input
              type="text"
              id="key"
              name="key"
              value={config.key}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label" htmlFor="mongoDBURL">MongoDB URL:</label>
            <input
              type="text"
              id="mongoDBURL"
              name="mongoDBURL"
              value={config.mongoDBURL}
              onChange={handleChange}
              className="form-control"
              required
            />
            <>Your URL should be like this{" ->"} mongodb://localhost:27017/Pchat </>
          </div>

          <div className="mb-3">
            <label className="form-label" htmlFor="port">Port:</label>
            <input
              type="number"
              id="port"
              name="port"
              value={config.port}
              onChange={handleChange}
              className="form-control"
              required
            />
            <>You can use 5000 as default</>
          </div>

          <div className="mb-3">
            <label className="form-label" htmlFor="peerPort">Screen Sharing Port:</label>
            <input
              type="number"
              id="peerPort"
              name="peerPort"
              value={config.peerPort}
              onChange={handleChange}
              className="form-control"
              required
            />
            <>You can use 5001 as default</>
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <button type="submit" className="btn btn-primary" style={{ backgroundColor: "#8ec73c", border: "none" }}>Save Configuration</button>
        </form>
      </main>
      {!login.isLogin && <Footer />}
    </>
  );
}

export default ConfigurationForm;
